<template>
	<div class="lane-filters-wrapper">
		<div class="container-wrapper search-row-container-wrapper" id="lane-filters-container">
			<div class="search-row-container container wide">
					<div class="search-row">
							<div class="search-row__search-bar search-bar-col">
									<b-input-group>
											<b-form-input class="input-search" placeholder="Search..." v-model="globalSearch" v-on:keyup.enter="searchGlobal"/>
											<b-input-group-append class="vdp-datepicker__search-button">
													<button type="button" class="btn" @click="searchGlobal()"><i class="icon-search"></i></button>
											</b-input-group-append>
											<b-input-group-append class="vdp-datepicker__clear-button" v-if="globalSearch">
													<button type="button" class="btn" @click="clearSearch();searchGlobal()">&times;</button>
											</b-input-group-append>
									</b-input-group>
							</div>
							<div class="search-row__datepicker datepicker-bar-col">
												<date-range-picker
														v-model="filterDate"
														show-dropdowns
														opens="center"
														@update="onDateRangeSelect"
														:ranges="dateRangePickerRanges"
														:auto-apply="true"
														single-date-picker="range"
												>
												<template v-slot:input="picker" style="min-width: 350px;">
														<span v-if="picker.startDate && picker.endDate" v-html="formatDateRange(picker.startDate,picker.endDate)">
														</span>
														<span v-else>Start/End Date</span>
												</template>
											</date-range-picker>

							</div>
							<div class="search-row__messages-count">
									<button type="button" class="btn" @click="toggleMessages" id="list-filter-messages-button">
									<img v-if="unreadMessagesCount > 0" src="/img/nav/icon-messages-inverse.svg" alt="Messages" /><img v-if="unreadMessagesCount == 0" src="/img/nav/icon-messages.svg" alt="Messages" /><span v-html="getMessageTitle">99 Messages</span>
									</button>
							</div>
							<div class="search-row__updates-count">
									<button type="button" class="btn" @click="toggleUpdates" id="list-filter-updates-button">
									<img v-if="unreadUpdatesCount > 0" src="/img/nav/icon-bell-circle-inverse.svg" alt="Updates" /><img v-if="unreadUpdatesCount == 0" src="/img/nav/icon-bell-circle.svg" alt="Updates" /><span v-html="getUpdateTitle">0 Updates</span>
									</button>
							</div>
							<div class="search-row__filter-button d-flex">
									<div class="advance-search-filter" @click="toggleAdvancedSearch">
											<img src="/img/nav/icon-filter-dark-reverse.svg" alt="filter"  v-if="hasAdvancedFilters()" /><img src="/img/nav/icon-filter-dark.svg" alt="filter"  v-if="!hasAdvancedFilters()"/> FILTERS <span class="badge badge-secondary" v-if="1 == 2 && hasAdvancedFilters()" v-html="advancedFilterCount()"></span> <img src="../assets/downarrow.svg" alt="downarrow"
													:class="{'advance-arrow': true, 'up': showAdvancedSearch}" />
									</div>

									<button type="button" class="btn search-row__filter-clear-button"     v-if="hasAdvancedFilters()" @click="resetArgs()">
											&times;<span v-html="resetText"></span>
									</button>
							</div>

							<div v-if="showEmergencyClosureButton || showEmergencyRestrictionButton || showNewContraventionButton" class="search-row__actions">
							<button v-if="showEmergencyClosureButton && !$store.getters.isReadOnly()" class="quick-switch__action-button btn btn-secondary" @click="$emit('submit:reportemergencyclosure')">
								Report Emergency Closure
							</button>
							<button  v-if="showEmergencyRestrictionButton && !$store.getters.isReadOnly()" class="quick-switch__action-button btn btn-secondary" @click="$emit('submit:reportemergencyrestriction')">
								Report Emergency Restriction
							</button>
							<button v-if="showNewContraventionButton && !$store.getters.isReadOnly()" class="quick-switch__action-button btn btn-secondary" @click="$emit('submit:newcontravention')">
								New Request with Violation
							</button>
							</div>


					</div>
			</div>
	</div>
	<b-modal v-model="showAdvancedSearch" @hidden="setArgs"  ok-only ok-title="Search" title="Enter Search Criteria">
	<div class="container-wrapper advance-search-container-wrapper">
<div id="advance-search" :class="{'expanded': showAdvancedSearch, 'container':true, 'wide':true, 'advance-search-container':true}">
<b-collapse :visible="showAdvancedSearch" class="advance-search-expandable">
<b-row>
<b-col lg>
<b-form-group label="" :state="filterMine.status" :invalid-feedback="filterMine.invalidMessage">
	<b-form-checkbox :checked="filterMine.value == 1" v-model="filterMineModel" key="filterMine" :unchecked-value="0" :value="1" name="filterMine"><span>Show My Requests</span></b-form-checkbox>
	</b-form-group>
</b-col>
</b-row>

		<template v-for="(column, i) in columns">
		<b-row v-if="column.key !== 'requesterProjectName' && column.key !== 'date'" :key="'i2'+i" v-show="column.filter && column.filter.show">
		<b-col lg  :class="getAdvanceSearchColumnClasses(column.key)">
				<b-form-group
						:label="((column.alternateLabel ? column.alternateLabel : column.label) + (column.key === 'date' ? ' [mm/dd/yyyy]' : '')) | capitalize"
						label-size="sm"
:label-for="fieldId(column.key)"
				>
						<!-- IMPORTANT: Trigger to force update auto-complete component -->
						<!-- <marker v-if="column.filter && column.filter.autoComplete">{{ getArgValues(column.filter.key, column.filter.autoComplete.label) }}</marker> -->
						<slot v-if="column.key === 'date'">
								<date-range-picker
										v-model="filterDate"
										show-dropdowns
										opens="center"
										@update="onDateRangeSelect"
										:ranges="dateRangePickerRanges"
										:auto-apply="true"
								/>
						</slot>
						<slot v-else-if="column.filter && column.filter.autoComplete && column.key === 'requesterProjectName'">
								<multiselect
									class="custom-multiselect"
									ref="requesterProjectFilter"
									v-model="arg[column.filter.key]"
									track-by="id"
									open-direction="bottom"
									label="label"
									:options="requesterProjectOptions"
									:show-labels="false"
									:multiple="false"
									:close-on-select="true"
									:hide-selected="false"
									:preserve-search="false"
									:clear-on-select="true"
									:internal-search="false"
										placeholder="Select or start typing"
									:loading="isRequesterProjectLoading"
									@search-change="onRequesterProjectSearch"
									:preselect-first="true"
:id="fieldId(column.key)"
									@select="onRequesterProjectInput(column.filter.key)"
									@input="onRequesterProjectInput(column.filter.key)"
									@blur="onRequesterProjectInput(column.filter.key)"
									@keydown.tab="onRequesterProjectInput(column.filter.key)"
								>
									<template slot="selection" slot-scope="{ values, search, isOpen }">
										<span
											class="multiselect__single"
											v-if="values.length && !isOpen"
											v-html="getOptionSelected(values.length)"
										></span>
									</template>
									<template slot="option" slot-scope="props">
										<div class="option__desc">
											<span class="option__title">{{ props.option.label }}</span><br>
										</div>
									</template>
									<template slot="noOptions">
									</template>
									<template slot="afterList">
										<li class="multiselect__after-list">Start typing to find projects.</li>
									</template>
									<template slot="noResult">
										No results. Please try changing the search query.
									</template>
								</multiselect>
						</slot>
						<slot v-else-if="column.filter && column.filter.autoComplete && column.key === 'affectedStreet'">
									<multiselect
										class="custom-multiselect"
										ref="affectedStreetFilter"
										v-model="arg[column.filter.key]"
										track-by="id"
										open-direction="bottom"
										label="label"
										:options="affectedStreetOptions"
										:show-labels="false"
										:multiple="false"
										:close-on-select="true"
										:hide-selected="false"
										:preserve-search="false"
										:clear-on-select="false"
										:internal-search="false"
										placeholder="Select or start typing"
										:loading="isAffectedStreetsLoading"
										@search-change="onAffectedStreetSearch"
										@select="onAffectedStreetInput"
									>
										<template slot="selection" slot-scope="{ values, search, isOpen }">
											<span
												class="multiselect__single"
												v-if="values.length && !isOpen"
												v-html="getOptionSelected(values.length)"
											></span>

										</template>
										<template slot="option" slot-scope="props">
											<div class="option__desc">
												<span class="option__title">{{ props.option.label }}</span><br>
											</div>
										</template>
										<template slot="noOptions">
										</template>
										<template slot="afterList">
											<li class="multiselect__after-list">Start typing to find streets.</li>
										</template>

										<template slot="noResult">
											No results. Please try changing the search query.
										</template>
									</multiselect>

								<treeselect
										:multiple="false"
										:async="true"
										:limit="1"
										:clearable="true"
										:load-options="loadOptions2"
										:placeholder="'Find '+(column.alternateLabel ? column.alternateLabel : column.label) | capitalize"
										v-model="arg[column.filter.key]"
										v-if="1==2"
																						openDirection="above"
																						:maxHeight="120"

								>
										<div slot="value-label" slot-scope="{ node }">{{ parseLabel(node, column.filter.key+'_label') }}</div>
								</treeselect>
						</slot>


								<!-- v-model="arg[column.filter.key]['arg'][column.filter.autoComplete.label]"
								<input-auto-complete v-if="column.filter && column.filter.autoComplete"
										:action="column.filter.autoComplete.search"
										:selection.sync="arg[column.filter.key] && arg[column.filter.key][column.filter.autoComplete.label]"
										:keyField="column.filter.key"
										:label="column.filter.autoComplete.label"
										:name="column.filter.autoComplete.name"
										:placeholder="'Find '+(column.alternateLabel ? column.alternateLabel : column.label) | capitalize"
										v-on:on:submit="onAutoCompleteSubmit"
								/> -->
				</b-form-group>
		</b-col>
		</b-row>
		</template>
		<b-row>
		<b-col lg>
				<b-form-group
																		label="Organization"
																		label-size="sm"
																		label-for="fs-filter-org"
																>
																	<treeselect
																		v-model="filterOrganization.value"
																		openDirection="below"
																		placeholder="Select Organization"
																		@input="onOrganizationInput"
																		:multiple="false"
																		:options="organizations"
																		:clearable="true"
																		:maxHeight="120"
																	>
																	</treeselect>
																</b-form-group>
																<b-form-group
						label="Peak Time"
						label-size="sm"
						label-for="fs-filter-peak-type"
				>
						<b-form-select id="fs-filter-peak-type" v-model="filterPeakTime.value" :options="LaneClosureRequest.getPeakTimeFilterOptions"
								@input="filterPeakTime.resetStatus()"
								:state="filterPeakTime.status"
								value-field="id"
								text-field="name"
								@change="togglePeakTime"
						></b-form-select>
				</b-form-group>
		</b-col>
		</b-row>

		<b-row>
		<b-col lg>
				<b-form-group
						label="Closure Type"
						label-size="sm"
						label-for="fs-filter-closure-type"
				>
						<b-form-select id="fs-filter-closure-type" v-model="filterClosureType.value" :options="LaneClosureRequest.getClosureTypeFilterOptions"
								@input="filterClosureType.resetStatus()"
								:state="filterClosureType.status"
								value-field="id"
								text-field="name"
								@change="toggleClosureType"
						></b-form-select>
				</b-form-group>
		</b-col>
	</b-row>
		<template v-for="(column, i) in columns">
		<b-row v-if="column.key === 'requesterProjectName'" :key="'i2'+i" v-show="column.filter && column.filter.show">
		<b-col lg  :class="getAdvanceSearchColumnClasses(column.key)">
				<b-form-group
						:label="((column.alternateLabel ? column.alternateLabel : column.label) + (column.key === 'date' ? ' [mm/dd/yyyy]' : '')) | capitalize"
						label-size="sm"
:label-for="fieldId(column.key)"
				>
						<slot v-if="column.filter && column.filter.autoComplete && column.key === 'requesterProjectName'">
								<multiselect
									class="custom-multiselect"
									ref="requesterProjectFilter"
									v-model="arg[column.filter.key]"
									track-by="id"
									open-direction="bottom"
									label="label"
									:options="requesterProjectOptions"
									:show-labels="false"
									:multiple="false"
									:close-on-select="true"
									:hide-selected="false"
									:preserve-search="false"
									:clear-on-select="true"
									:internal-search="false"
										placeholder="Select or start typing"
									:loading="isRequesterProjectLoading"
									@search-change="onRequesterProjectSearch"
									:preselect-first="true"
:id="fieldId(column.key)"
									@select="onRequesterProjectInput(column.filter.key)"
									@input="onRequesterProjectInput(column.filter.key)"
									@blur="onRequesterProjectInput(column.filter.key)"
									@keydown.tab="onRequesterProjectInput(column.filter.key)"
								>
									<template slot="selection" slot-scope="{ values, search, isOpen }">
										<span
											class="multiselect__single"
											v-if="values.length && !isOpen"
											v-html="getOptionSelected(values.length)"
										></span>
									</template>
									<template slot="option" slot-scope="props">
										<div class="option__desc">
											<span class="option__title">{{ props.option.label }}</span><br>
										</div>
									</template>
									<template slot="noOptions">
									</template>
									<template slot="afterList">
										<li class="multiselect__after-list">Start typing to find projects.</li>
									</template>
									<template slot="noResult">
										No results. Please try changing the search query.
									</template>
								</multiselect>

						</slot>
				</b-form-group>
		</b-col>
		</b-row>
		</template>
		<b-row>
		<b-col lg>
				<b-form-group
						label="Completion"
						label-size="sm"
						label-for="fs-filter-completed-request"
				>
						<b-form-select id="fs-filter-completed-request" v-model="filterCompleted.value" :options="LaneClosureRequest.getLaneClosureCompletionOptions"
								@input="filterCompleted.resetStatus()"
								:state="filterCompleted.status"
								value-field="id"
								text-field="name"
								@change="toggleCompleted"
						></b-form-select>
				</b-form-group>
		</b-col>
		</b-row>
		<b-row>
		<b-col id="search-col">
				<div class="search-col__button-wrapper">
				<b-button id="search-btn" size="sm" @click="setArgs">Search</b-button>
				</div>
		</b-col>
		</b-row>

</b-collapse>
</div>

</div>
</b-modal>

<div class="quick-switch-container-wrapper">
<div class="quick-switch-container container wide" v-if="storeModule == 'reportContraventionList' &&  !showNewContraventionButton">
	<div class="quick-switch hide-mobile">
			<div class="quick-switch__contraventions-title" v-html="title"></div>
		</div>
</div>
<div class="quick-switch-container container wide" v-if=" (storeModule == 'reportContraventionList' && showNewContraventionButton) || storeModule != 'reportContraventionList'">
		<div class="quick-switch hide-mobile">
				<div class="quick-switch__title" v-html="title"></div>
				<div class="quick-switch__full-total" v-for="(task, index) in Totals" :key="'index'+index">
						<div class="quick-switch__item-total lane-column" :class="{ 'blue-background': activeList === index }">
								<caption class="badge-title" style="white-space:nowrap" @click="$emit('update:status', index)">
										<span :style="{ 'order': activeList === index ? '2' : 'initial' }">&nbsp;{{ task.taskTitle }}&nbsp;</span><b-badge>{{ task.total }}</b-badge>
								</caption>
										<b-button style="white-space:nowrap"
												v-for="(item, i) in task.status" :key="'i'+i"
												@click="$emit('update:status', index, item.name)"
												v-show="activeList === index && callOptionMethod"
												:class="activeList === index && activeTabName === item.name ? 'active':'inactive'"
										>
												{{ item.name | capitalize }} <b-badge v-text="item.count"></b-badge>
										</b-button>
						<button v-show="activeList === index && callOptionMethod" class="quick-switch__refresh-quick-switch btn" @click="$emit('update:refresh')">
								<img src="/img/nav/icon-refresh-quick-switcher.svg" alt="filter" />
						</button>

						</div>

				</div>
				<button v-if="showPrintPdf" class="quick-switch__action-button quick-switch__action-button--download btn btn-secondary" @click="$emit('submit:printpdf')" :disabled="printing">
						<slot v-if="printing"><b-spinner small label="Saving..." class="ml-2" v-if="printing"></b-spinner></slot>
						<slot v-else><font-awesome-icon icon="print" /></slot>
				</button>
				<div class="sort-option" :class="showPrintPdf ? ['quick-switch__sort-by'] : ['quick-switch__sort-by','no-border']">
						<b-form-group
								label="Sort"
								label-size="sm"
								label-cols="auto"
								content-cols="auto"
								label-for="fs-filter-sort-by"
								label-class="sr-only"
						>
								<b-form-select
										id="fs-filter-sort-by"
										:options="LaneClosureRequest.getSortOptions"
										@input="filterSortBy.resetStatus()"
										:state="filterSortBy.status"
										v-model="filterSortBy.value"
										@change="sortByChange"
								/>
						</b-form-group>
				</div>
				</div>
</div>
</div>
</div>
</template>

<script>
import Vue from 'vue'
import treeselect from '@riophae/vue-treeselect'
import Contravention from './../models/Contravention'
import LaneClosureRequest from './../models/LaneClosureRequest'
import BootstrapField from './../utility/BootstrapField';


export default {
		name: 'LaneFilters',
		components: {
				treeselect,
		},
		props: {
				columns: Array,
				totals: Object,
				activeList: Number,
				activeTabName: String,
				callOptionMethod: String,
				unreadMessagesCount:Number,
				unreadUpdatesCount:Number,
				title:String,
				printing:Boolean,
				storeArgs:String,
				storeModule:String,
				showEmergencyClosureButton:Boolean,
				showEmergencyRestrictionButton:Boolean,
				showNewContraventionButton:Boolean,
				canCreateContravention:Boolean,
				showPrintPdf:Boolean,
		},
		data: () => ({
				showAdvancedSearch: false,
				showLaneFilter: false,
				arg: {},
		Contravention,
				organizations: [],
				filterOrganization: new BootstrapField({
					value: null,
				}),
				filterCompleted: new BootstrapField({
								value: 0,
						}),
				filterClosureType: new BootstrapField({
						value: null,
				}),
				filterPeakTime: new BootstrapField({
						value: null,
				}),
				filterMine: new BootstrapField({
						value: 1,
				}),
				filterMineModel:false,
				globalSearch: null,
				isAffectedStreetsLoading:false,
				isRequesterProjectLoading:false,
				affectedStreetOptions:[{
										id: null,
										label: "Any Street",
								}],
				requesterProjectOptions:[{
										id: null,
										label: "Any Project",
								}],
				LaneClosureRequest,
				filterDate: {
						startDate: null,
						endDate: null,
				},
				filterSortBy: new BootstrapField({
						value: '',
				}),

		}),
		created() {
			this.getOrganizationsForTreeSelect();
		},
		mounted() {
				if ( this.columns ) {
						this.columns.forEach(item => {
								if ( item.filter ) {
										// if ( item.filter.autoComplete && item.filter.show ) {
										this.getArgs(item.filter)
										// }
								}
						})
				}
				this.getAdvancedSearch();

				Vue.prototype.$bus.$off("filter:showMineApplied", this.setShowMineApplied);
				Vue.prototype.$bus.$on("filter:showMineApplied", this.setShowMineApplied);


		},
		watch: {
			'arg':function() {
				localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
			},
			'filterMineModel':function() {
				this.filterMine.value = this.filterMineModel;
				this.arg['showMine'] = this.filterMine.value;
				Vue.prototype.$bus.$emit("filter:setShowMine", this.filterMine.value);
			},
			'globalSearch': function() {
				this.arg['keywords'] = this.globalSearch;
				localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
				this.$emit('update:filters');
			}
		},
		computed: {
				resetText() {
						if (this.advancedFilterCount() == 1) {
							return "Reset " + this.advancedFilterCount() + " filter";
						} else {
							return "Reset " + this.advancedFilterCount() + " filters";
						}


				},
				getMessageTitle() {
					if (this.unreadMessagesCount == 1) {
								return "1 Message";
					} else {
								return this.unreadMessagesCount + " Messages";
					}
				},
				getUpdateTitle() {
					if (this.unreadUpdatesCount == 1) {
								return "1 Update";
					} else {
								return this.unreadUpdatesCount + " Updates";
					}
				},
				Totals() {
						let lists = [];
						let showOnlyModule = null;
						let taskTitle = "Requests";
						if (this.storeModule == "reportContraventionList")  {
							showOnlyModule = "contraventions";
						}
						if (this.storeModule == "reportClosureList")  {
							showOnlyModule = "closures";
						}
						if (this.storeModule == "reportRestrictionList")  {
								showOnlyModule = "restrictions";
							}

						if (showOnlyModule != null) {
							for (let item in this.totals) {
									if (item == showOnlyModule) {
											let attr = [],
													total = 0
											for (let key in this.totals[item]) {
													attr.push({
															name: key,
															count: parseInt(this.totals[item][key])
													})
													total += parseInt(this.totals[item][key])
											}
											taskTitle = "Requests";

											if (item == "contraventions")  {
													taskTitle = "Requests";
												}
											if (item == "closures")  {
													taskTitle = "Closures";

												}
												if (item == "restrictions")  {
													taskTitle = "Restrictions";
												}
											lists.push({
													taskName: item,
													taskTitle: taskTitle,
													total,
													status: attr
											})
									}
							}

					} else {
							// show all modules except contraventions
							for (let item in this.totals) {
									if (item != "contraventions") {
											let attr = [],
													total = 0
											for (let key in this.totals[item]) {
													attr.push({
															name: key,
															count: parseInt(this.totals[item][key])
													})
													total += parseInt(this.totals[item][key])
											}
											taskTitle = "Requests";
											if (item == "contraventions")  {
												taskTitle = "Violations";
											}
											if (item == "closures")  {
												taskTitle = "Closures";

											}
											if (item == "restrictions")  {
												taskTitle = "Restrictions";
												}
											lists.push({
													taskName: item,
													taskTitle: taskTitle,
													total,
													status: attr
											})
									}
							}
			}
						return lists
				},

				dateRangePickerRanges() {
						return {
								'No Date': [null, null],
								'Yesterday': [this.$moment().subtract(1, 'days').toDate(), this.$moment().subtract(1, 'days').toDate()],
								'Last week': [this.$moment().subtract(7, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
								'Last two week': [this.$moment().subtract(14, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
								'Today': [this.$moment().toDate(), this.$moment().toDate()],
								'This week': [this.$moment().startOf('week').toDate(), this.$moment().endOf('week').toDate()],
								'Next week': [this.$moment().startOf('week').add(7, 'days').toDate(), this.$moment().endOf('week').add(7, 'days').toDate()],
								'Next two weeks': [this.$moment().startOf('week').add(7, 'days').toDate(), this.$moment().endOf('week').add(14, 'days').toDate()],
						};
				}
		},
		methods: {
				formatDateRange(startDate,endDate) {
						let sd = this.$moment(startDate);
						let ed = this.$moment(endDate);
						return sd.format('MM/DD/YYYY') + " - " + ed.format('MM/DD/YYYY');
				},

				hasAdvancedFilters() {
					if (this.$store.getters.userInfo() == null) {
							return false;
					}
						for (let item in this.arg) {
							if (this.arg[item] != null ) {
								if (item != "completed" && item != "keywords" && item != "closureType" && item != "peakTime"
									&& item != "fromDateTime" && item != "toDateTime" && item != "sortBy" && item != "sortOrder"
									&& item != "showMine" && item != "RequesterOrganizationId"
									) {
									if(item == "requesterProjectId") {
											if (this.arg[item].id != null) {
											return true;
											}
									} else {
										return true;
									}
								}
							}
						}
						if (this.filterCompleted.value !== 0) {
								return true;
						}
						if (this.filterClosureType.value !== null) {
								return true;
						}
						// if (this.filterMine.value !== this.$store.getters.userInfo().showMine) {
						// 		return true;
						// }
						if (this.filterOrganization.value !== null && this.filterOrganization.value !== undefined) {
								return true;
						}
						if (this.filterPeakTime.value !== null) {
								return true;
						}
						// if (this.filterDate.startDate || this.filterDate.endDate) {
						//     if (this.filterDate.startDate != "Invalid Date" && this.filterDate.endDate != "Invalid Date") {
						//         return true;
						//     }
						// }
						return false;
				},

				advancedFilterCount() {
					if (!this.$store.getters.userInfo()) {
							return 0;
					}
						let count = 0;
						for (let item in this.arg) {
							if (this.arg[item] != null ) {
								if (item != "completed" && item != "keywords" && item != "closureType" && item != "peakTime"
									&& item != "fromDateTime" && item != "toDateTime" && item != "sortBy" && item != "sortOrder"
									&& item != "showMine" && item != "RequesterOrganizationId"
									) {
									if(item == "requesterProjectId") {
											if (this.arg[item].id != null) {
													count++;
											}
									} else {
										// console.log(item+":"+this.arg[item]);
										count++;
									}
								}
							}
						}
/*

if(item != "showMine" || item != "completed" || item != "closureType" || item != "peakTime") {
} else if (this.arg[item] != null) {
		if (item != "closureType") {
			count++;
		}
}
*/
						if (this.filterCompleted.value !== 0) {
								count++;
						}
						if (this.filterClosureType.value !== null) {
								count++;
						}
						// if (this.filterMine.value !== this.$store.getters.userInfo().showMine) {
						// 		count++;
						// }
						if (this.filterOrganization.value !== null && this.filterOrganization.value !== undefined) {
								count++;
						}
						if (this.filterPeakTime.value !== null) {
								count++;
						}
						// if (this.filterDate.startDate || this.filterDate.endDate) {
						//     if (this.filterDate.startDate != "Invalid Date" && this.filterDate.endDate != "Invalid Date") {
						//         count++;
						//     }
						// }
						return count;
				},
				handleAutocomplete(value, instanceId) {
						this.setArgs();
				},

				fieldId(name) {
						return this.storeArgs+"-field-"+name;
				},
				parseLabel(node, argAttr) {
						if ( node.label ) {
								if ( node.label.indexOf('(unknown)') > -1 ) {
										node.label = this.arg[argAttr]
								} else {
										this.arg[argAttr] = node.label
								}
						}
						return node.label
				},

				clickOutsideAdvanceSearch(e) {
					let filterBox = document.getElementById('lane-filters-container');
					let advanceSearchBox = document.getElementById('advance-search');
					let laneFilterMessageButton = document.getElementById('list-filter-messages-button');
					let laneFilterUpdateButton = document.getElementById('list-filter-updates-button');
					let keepOpen = false;
					if (advanceSearchBox) {
						if (advanceSearchBox.contains(e.target)) {
							keepOpen = true;
						}
					}
					if (filterBox) {
						if (filterBox.contains(e.target)) {
							keepOpen = true;
						}
					}
						if (laneFilterMessageButton) {
							if (laneFilterMessageButton.contains(e.target)) {
								keepOpen = false;
							}
						}
						if (laneFilterUpdateButton) {
							if (laneFilterUpdateButton.contains(e.target)) {
								keepOpen = false;
							}
						}
						if (!keepOpen) {
							this.hideAdvanceSearch();
						}
				},
				toggleAdvancedSearch() {
					this.showAdvancedSearch = !this.showAdvancedSearch
					this.saveAdvancedSearch();
					this.$nextTick(() => {
						if (this.showAdvancedSearch) {
							window.addEventListener('click', this.clickOutsideAdvanceSearch);
						}
						else {
							window.removeEventListener('click', this.clickOutsideAdvanceSearch);
						}
					});
				},

				hideAdvanceSearch() {
					if (this.showAdvancedSearch) {
						this.showAdvancedSearch = false;
						window.removeEventListener('click', this.clickOutsideAdvanceSearch);
					}
				},



				toggleMessages() {
						this.$emit('lanefilters:togglemessages');
				},
				toggleUpdates() {
						this.$emit('lanefilters:toggleupdates');
				},
				saveAdvancedSearch() {
						localStorage.setItem('showAdvancedSearch', this.showAdvancedSearch)
				},
				getAdvanceSearchColumnClasses(field) {
					return 'advance-search__'+field;
				},
				getAdvancedSearch() {
						this.showAdvancedSearch = false;
						/*
						let testValue = localStorage.getItem('showAdvancedSearch');
						if (testValue == "true") {
								this.showAdvancedSearch = true;
						} else {
								this.showAdvancedSearch = false;
						}
						*/
				},
				getOptionSelected(qty) {
					if (qty == 1) {
						return qty + " option selected";
					} else {
						return qty + " options selected"
					}
				},

				searchGlobal() {
						this.arg['keywords'] = this.globalSearch
						this.setArgs();
						// this.$emit('submit:filters')
				},

				toggleCompleted() {
						this.arg['completed'] = this.filterCompleted.value;
				},


				// onAutoCompleteSubmit(result, value, name, keyField) {
				//     this.arg[keyField] = result[value]
				//     this.setArgValues(keyField, result, name)
				//     this.$emit('update:filters', { [keyField]: result[name] })
				// },


				getArgValues(keyField, label) {
						let argQuery = JSON.parse(localStorage.getItem(this.storeFilter))
						if (argQuery == null) {
								argQuery = {};
						}

						if (argQuery != null) {
								if ( !Array.isArray(argQuery) ) {
										if ( argQuery[keyField] ) {
												this.arg[keyField] = argQuery[keyField]
										}
								}
								if ( !this.arg[keyField] ) {
										this.arg[keyField] = {}
										if ( label ) {
												this.arg[keyField][label] = ''
										}
								}
								}
				},


				clearArgs( filters ) {
						this.arg = {
								...this.arg,
								[filters.key]: null,
								[filters.key+'_label']: null
						}
				},
				getArgs( filters ) {
						let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
						if (argQuery == null) {
								argQuery = {};
						}
						// if ( this.arg === undefined )

						if ( filters.autoComplete ) {
								this.arg = {
										...this.arg,
										[filters.key]: argQuery[filters.key]
								}
						} else if ( filters.datePicker ) {
							let startMoment = null;
							let endMoment = null;
							if (argQuery[filters.datePicker.from] != undefined) {
								startMoment = this.moment(argQuery[filters.datePicker.from]);
								if (startMoment.isValid()) {
								    startMoment.hours(0);
								    startMoment.minutes(0);
								    startMoment.seconds(0);
									this.arg = {
									    ...this.arg,
									    [filters.datePicker.from]: startMoment.format(),
									}
									this.filterDate.startDate = new Date(startMoment.format());
								} else {
									argQuery[filters.datePicker.from] = null;
									this.arg = {
									    ...this.arg,
									    [filters.datePicker.from]: null,
									}
									this.filterDate.startDate = null;
								}
							}
							if (argQuery[filters.datePicker.to] != undefined) {
								endMoment = this.moment(argQuery[filters.datePicker.to]);
								if (endMoment.isValid()) {
								    endMoment.hours(23);
								    endMoment.minutes(59);
								    endMoment.seconds(59);
								this.arg = {
										...this.arg,
								        [filters.datePicker.to]: endMoment.format(),
								    }
									this.filterDate.endDate = new Date(endMoment.format());
								} else {
									argQuery[filters.datePicker.to] = null;
									this.arg = {
									    ...this.arg,
									    [filters.datePicker.to]: null,
								}
									this.filterDate.endDate = null;
						}
							}

								// if (argQuery[filters.datePicker.from] != undefined) this.filterDate.startDate = new Date(argQuery[filters.datePicker.from]);
								// if (argQuery[filters.datePicker.to] != undefined) this.filterDate.endDate = new Date(argQuery[filters.datePicker.to]);

								// if (argQuery[filters.datePicker.from] == "Invalid date") {
								// 	argQuery[filters.datePicker.from] = null;
								// 	this.filterDate.startDate = null;
								// }
								// if (argQuery[filters.datePicker.to] == "Invalid date") {
								// 	argQuery[filters.datePicker.to] = null;
								// 	this.filterDate.endDate = null;
								// }
								// this.arg = {
								// 		...this.arg,
								// 		[filters.datePicker.from]: argQuery[filters.datePicker.from] != undefined ? argQuery[filters.datePicker.from] : null,
								// 		[filters.datePicker.to]: argQuery[filters.datePicker.to] != undefined ? argQuery[filters.datePicker.to] : null,
								// }
						}
						// pull in the global search and completed request filter.
						if (argQuery != null) {
								if (argQuery.keywords) {
										this.globalSearch = argQuery.keywords;
								} else {
										this.globalSearch = null;
								}
								if (typeof argQuery.completed != "undefined") {
										this.filterCompleted.value = argQuery.completed;
										this.arg["completed"] = argQuery.completed;
								}
								if (typeof argQuery.closureType != "undefined") {
										this.filterClosureType.value = argQuery.closureType;
										this.arg["closureType"] = argQuery.closureType;
								}
								if (typeof argQuery.peakTime != "undefined") {
										this.filterPeakTime.value = argQuery.peakTime;
										this.arg["peakTime"] = argQuery.peakTime;
								}
								if (typeof argQuery.RequesterOrganizationId != "undefined") {
										this.filterOrganization.value = argQuery.RequesterOrganizationId;
										this.arg["RequesterOrganizationId"] = argQuery.RequesterOrganizationId;
								}
								if (argQuery.sortOrder && argQuery.sortBy) {
										this.filterSortBy.value = argQuery.sortBy + " " + argQuery.sortOrder;
										this.arg['sortBy'] = argQuery.sortBy;
										this.arg['sortOrder'] = argQuery.sortOrder;
								}
						} else {
								this.globalSearch = null;
								this.filterCompleted.value = null;
								this.filterClosureType.value = null;
								this.filterOrganization.value = null;
								this.filterPeakTime.value = null;
								this.filterDate = { startDate: null, endDate: null };
								this.filterSortBy.value = '';
						}

						// read in the global filter.
						let globalQuery = JSON.parse(localStorage.getItem("globalFilter"))
						if (globalQuery == null) {
								globalQuery = {};
						}
						if (typeof globalQuery.showMine != "undefined") {
								this.filterMine.value = globalQuery.showMine;
								this.filterMineModel = globalQuery.showMine;
								this.arg["showMine"] = globalQuery.showMine;
						}
						this.getAdvancedSearch();
				},
				setArgs() {
						this.showAdvancedSearch = false;
						localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
						this.$emit('submit:filters')
				},
				resetArgs() {
						this.arg = Array()
						this.$store.dispatch(this.storeModule+'/clearParams')
						this.columns.map(elem => {
								if (elem.filter != undefined ) {
										if (elem.filter.show) {
												this.clearArgs(elem.filter)
										}
								}
						})
						this.filterCompleted.value = 0;
						this.filterClosureType.value = null;
						this.filterOrganization.value = null;
						this.filterPeakTime.value = null;

						let globalQuery = JSON.parse(localStorage.getItem("globalFilter"))
						if (globalQuery != null) {
							if (typeof globalQuery.showMine != "undefined") {
									this.arg["showMine"] = globalQuery.showMine;
									this.filterMine.value = globalQuery.showMine;
							}
						}

						// this.filterDate = { startDate: null, endDate: null };
						this.setArgs();
						this.showAdvancedSearch = false;
						this.saveAdvancedSearch();
						// this.$emit('submit:filters')
				},

				onDatePickerChange(input, keyField) {
						let theDate = this.moment(input);
						let dateString = null;
						if (theDate.isValid()) {
								if (keyField == "fromDateTime") {
										theDate.hours(0);
										theDate.minutes(0);
										theDate.seconds(0);
								}
								if (keyField == "toDateTime") {
										theDate.hours(23);
										theDate.minutes(59);
										theDate.seconds(59);
								}
								dateString = theDate.format();
						}

						this.arg = {
								...this.arg,
								[keyField]: dateString
						}
				},
				onDateRangeSelect(date) {
						let startMoment = this.moment(date.startDate);
						let endMoment = this.moment(date.endDate);

						if (startMoment.isValid()) {
								startMoment.hours(0);
								startMoment.minutes(0);
								startMoment.seconds(0);
								this.arg = {
										...this.arg,
										fromDateTime: startMoment.format(),
						}
						} else {
							this.arg = {
									...this.arg,
									fromDateTime: null,
							}

						}
						if (endMoment.isValid()) {
								endMoment.hours(23);
								endMoment.minutes(59);
								endMoment.seconds(59);
								this.arg = {
										...this.arg,
										toDateTime: endMoment.format(),
						}
						} else {
						this.arg = {
								...this.arg,
									toDateTime: null,
							}
						}
						this.setArgs()
						this.$emit('submit:filters')

				},
		getOrganizationsForTreeSelect() {
			return this.$store.dispatch('organizationList/loadWorkFor', {})
				.then(() => {
					this.organizations = [];
					let result = this.$store.getters['organizationList/getRecords'];
					let refSet = [];
					let cityOrgs = [];
					let thirdPartyOrgs = [];
					let currentLevel = 1;
					let continueLoop = true;

					while (continueLoop) {
						if (currentLevel == 1) {
							let found_first_agency = false;

							result.forEach(x => {
								if (x.level == 1) {
									let o = {
										id: x.id,
										label: x.name,
										organizationTypeId: x.organizationTypeId
									}
									refSet.push(o);

									if (found_first_agency == false) {
										if (x.organizationTypeId == "agency") {
											found_first_agency = true;
											thirdPartyOrgs.push(o);
										} else {
											cityOrgs.push(o);
										}
									} else {
										thirdPartyOrgs.push(o);
									}
								}
							});
						} else {
							let newRef = [];
							result.forEach(x => {
								if (x.level == currentLevel) {
									let org = {
										id: x.id,
										label: x.name,
										parentId: x.parentId,
										organizationTypeId: x.organizationTypeId
									};

									newRef.push(org);
								}
							});

							newRef.forEach(x => {
								refSet.forEach(y => {
									if (x.parentId == y.id) {
										if (y.children == undefined) y.children = [];
										y.children.push(x);
									}
								});
							});

							refSet = newRef;
						}
						currentLevel++;
						if (refSet.length == 0) {
							continueLoop = false;
						}
					}
					this.organizations = [...cityOrgs, ...thirdPartyOrgs];
				});
		},

				onAffectedStreetInput(value, instance) {
				},
				onAffectedStreetSearch(input) {
						const index = 0;
					if(input != '') {
						this.isAffectedStreetsLoading = true;
						this.$store.dispatch(this.columns[index]['filter']['autoComplete']['search'], input)
						.then( res => {
								this.affectedStreetOptions = [];
								var item = {
										id: null,
										label: "Any Street",
								}
								this.affectedStreetOptions.push(item);

								for (var x = 0; x < res.length; x++) {
										item = {
												id: `${res[x][this.columns[index]['filter']['autoComplete'].name]}`,
												label: `${res[x][this.columns[index]['filter']['autoComplete'].label]}`,
										}
										this.affectedStreetOptions.push(item);
								}
								this.isAffectedStreetsLoading = false;

						})
					}
				},

				onRequesterProjectInput(filter) {
				},
				onRequesterProjectSearch(input) {
						var item = {};
						const index = 4; // 4th colum nin LaneClosureListModule...
						this.isRequesterProjectLoading = true;
						this.$store.dispatch(this.columns[index]['filter']['autoComplete']['search'], input)
						.then( res => {
								this.requesterProjectOptions = [];
								item = {
										id: null,
										label: "Any Project",
								}
								this.requesterProjectOptions.push(item);

								for (var x = 0; x < res.length; x++) {
										item = {
												id: `${res[x][this.columns[index]['filter']['autoComplete'].name]}`,
												label: `${res[x][this.columns[index]['filter']['autoComplete'].label]} (${res[x][this.columns[index]['filter']['autoComplete'].organizationName]})`,
										}
										this.requesterProjectOptions.push(item);
								}
								this.isRequesterProjectLoading = false;

						})
				},
				onOrganizationInput(input) {
					this.arg['RequesterOrganizationId'] = this.filterOrganization.value;
				},

				toggleClosureType() {
						this.arg['closureType'] = this.filterClosureType.value;
				},
				togglePeakTime() {
						this.arg['peakTime'] = this.filterPeakTime.value;
				},
				clearSearch() {
						this.globalSearch = null;
						this.searchGlobal();
				},
				onRefresh() {
						this.$emit('update:filters');
				},
				onNewContravention() {
					this.$emit('action:newrequest')
				},

				sortByChange(val) {
						if (val) {
								let vals = val.split(" ");
								this.arg['sortBy'] = vals[0];
								this.arg['sortOrder'] = vals[1];
						}
						else {
								this.arg['sortBy'] = this.arg['sortOrder'] = null;
						}
						this.setArgs();
						// this.$emit("submit:filters");
				},

				changeSortFromColumn(sortBy, sortOrder) {
						this.filterSortBy.value = sortBy + " " + sortOrder;
						this.sortByChange(this.filterSortBy.value);
				}

		}
}
</script>
